export default __webpack_public_path__ + "static/media/595.8862749f.png";